
/**
 * @name crud_admin_security_users.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\crud_admin_security_users.js
 */

//import { apiCall, getBaseDir } from './utils.js';

var getBaseDir = null, apiCall = null, getBranchNameFromId = null;

$(function()
{
    import('../../utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        getBranchNameFromId = utils.getBranchNameFromId;

        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname !== utils.getBaseDir() + 'administrativo/funcionarios')
            return;

        new AdminSecurityUsers(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
        });
    });
});

class AdminSecurityUsers
{
    constructor(onloadList=false, deps = {})
    {
        this.deps = deps;
        this.businessId = -1;
        this.securityGroupsList = [];
        let self = this;

        if (onloadList) {
            var intv = setInterval(function() {
                if (!window._sessionData.businessBranches)
                    return;
                
                clearInterval(intv);
                
                self.businessId = window._sessionData.businessId;

                let mountBranchesSelectHtml = '<option value="">-- Selecione --</option>';
                for(let i in window._sessionData.businessBranches) {
                    let branch = window._sessionData.businessBranches[i];
                    mountBranchesSelectHtml += `<option value="${branch.ID}">${branch.FILIAL}</option>`;
                }
                $('#insert_staff_business_branches').html(mountBranchesSelectHtml);
                $('#edit_staff_business_branches').html(mountBranchesSelectHtml);
                /*setTimeout(function() {
                    $('#insert_staff_business_branches').select2();
                    $('#edit_staff_business_branches').select2();
                }, 250);*/

                self.deps.apiCall({
                    method: 'GET',
                    endpoint: 'api/v1/business/roles',
                    successCallback: function(res) {
                        console.log('employee roles', res.data);

                        let mountSecurityGroupsSelectHtml = '<option value="">-- Selecione --</option>';
                        for(let i in res.data) {
                            let group = res.data[i];
                            mountSecurityGroupsSelectHtml += `<option value="${group.ID}">${group.FUNCAO}</option>`;
                        }
                        $('#insert_staff_roles').html(mountSecurityGroupsSelectHtml);
                        $('#edit_staff_roles').html(mountSecurityGroupsSelectHtml);
                        /*setTimeout(function() {
                            $('#insert_staff_roles').select2();
                            $('#edit_staff_roles').select2();
                        }, 250);*/

                        self.securityGroupsList = res.data;
                    },
                    errorCalback: function(res) {

                    }
                });

                self.getBusinessStaff()
                    .then(() => {
                        console.log('render getBusinessStaff list')
                    })
                    .then(() => {
                        self.bindElementsChanges();
                    });
            }, 1000);
        }
    }

    getBusinessStaff() {
        let self = this;
        return new Promise((resolve, reject) => {
            $(".js-security-staff-table").block(window._loader.loading);

            this.deps.apiCall({
                method: 'GET',
                endpoint: 'api/v1/employee/all',
                successCallback: function(res) {
                    resolve(true);

                    let tableHtml = '';
                    for(let i in res.data) {
                        let staff = res.data[i];
                        tableHtml += `
                            <tr>
                                <td data-label="#">${staff.ID}</td>
                                <td data-label="#">${staff.PRIMEIRO_NOME} ${staff.SOBRENOME}</td>
                                <td data-label="Filiais">${self.getUserBranchesListHTMLTags(staff.FILIAL_ID ? staff.FILIAL_ID.split(',') : [])}</td>
                                <td data-label="Status">${staff.STATUS == 'A' ? 'Ativo' : 'Inativo'}</td>
                                <td data-label="Ações">
                                    <div class="dropdown">
                                        <button class="btn btn-primary dropdown-toggle" type="button" id="dropdown-staff-${staff.ID}" data-bs-toggle="dropdown" aria-expanded="false">
                                            Ações
                                        </button>
                                        <ul class="dropdown-menu" aria-labelledby="dropdown-staff-${staff.ID}">
                                            <li><a class="dropdown-item js-update-security-staff-data" href="#" data-staff-data='${JSON.stringify(staff)}' data-bs-target="#modal-update-business-staff" data-bs-toggle="modal">Editar</a></li>
                                            <li class="d-none"><a class="dropdown-item js-delete-security-staff" href="#" data-staff-id='${staff.ID}'>Excluir</a></li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        `;
                    }
                    $('.js-security-staff-list').html(tableHtml);
                    $(".js-security-staff-table").unblock();
                },
                errorCalback: function(err) {
                    reject(false)
                }
            });
        });
    }

    getUserGroupListHTMLTags(list) {
        let html = '';
        for(let i in list) {
            for(let x in this.securityGroupsList) {
                let secGroup = this.securityGroupsList[x];
                if (secGroup.GROUP_ID == list[i]) {
                    html += `<span class="badge bg-primary mx-1 my-1">${secGroup.DESCRIPTION}</span>`;
                    continue;
                }
            }
        }
        return html;
    }

    getUserBranchesListHTMLTags(list) {
        let html = '';
        for(let i in list) {
            for(let x in window._sessionData.businessBranches) {
                let branch = window._sessionData.businessBranches[x];
                if (branch.ID == list[i]) {
                    html += `<span class="badge bg-primary mx-1 my-1">${branch.FILIAL}</span>`;
                    continue;
                }
            }
        }
        return html;
    }

    bindElementsChanges() {
        const self = this;
        // Detecta operador clicando para editar operador(usuário)
        $(document).on('submit', '.js-business-staff-update', function(e) {
            e.preventDefault();
            
            let data = $(this).serializeArray();

            var filtered = data.filter(function (el) {
                return el != null;
            });
            data = filtered;

            if (self.editSecurityUserId) {
                data.push({
                    name: 'edit_staff_id',
                    value: self.editSecurityUserId
                });
            }

            $(".modal-update-business-staff-dialog").block(window._loader.loading);
            apiCall({
                method: self.editSecurityUserId ? 'PUT' : 'POST',
                endpoint: 'api/v1/business/staff',
                data,
                successCallback: function(res) {
                    console.log('crud_admin_security_users.js/business/security/users/update', '.js-hunter-business-operator-update', res);
                    $(".modal-update-business-staff-dialog").unblock();

                    if (res.error) {
                        window.toast({
                            error: true,
                            text: res.message
                        })
                    } else {
                        self.getBusinessStaff()
                            .then(() => {
                                console.log('rerender getBusinessStaff list')
                            })
                        window.toast({
                            error: false,
                            text: res.message
                        })
                        $(".js-business-staff-update").trigger('reset');
                        $("#modal-update-business-staff").modal('hide');
                    }
                },
                errorCallback: function(err) {
                    $(".modal-update-business-staff-dialog").unblock();
                    //$(".modal-update-event-hunter-dialog").block(window._loader.error); // REMOVE COMMENT WHEN IN PRODUCTION
                    console.error('ERROR', 'crud_admin_security_users.js/business/security/users/update', '.js-hunter-business-operator-update', err);
                }
            })
        });

        // Detecta operador clicando para modificar um grupo(cargo)
        $(document).on('click', '.js-update-security-staff-data', function() {
            let userData = $(this).data('staff-data');

            self.editSecurityUserId = userData.ID;

            $(".js-business-staff-update").trigger('reset');

            $('.js-update-business-staff-dialog-title-id').html(`Editar Doutor #${self.editSecurityUserId}`);
            $('input[name="edit_staff_name"]').val(`${userData.PRIMEIRO_NOME}${userData.SOBRENOME != null ? ` ${userData.SOBRENOME}` : ''}`);
            $('input[name="edit_staff_email"]').val(userData.EMAIL);
            $('select[name="edit_staff_roles"]').val(userData.FUNCAO_ID).trigger('change');
            $('select[name="edit_staff_business_branches"]').val(userData.FILIAL_ID).trigger('change');
            $('select[name="edit_staff_active"]').val(userData.STATUS);
            $('select[name="edit_staff_is_doctor"]').val(userData.DOUTOR);
            $('input[name="edit_staff_login"]').val(userData.LOGIN);
            $('input[name="edit_staff_login"]').prop('readonly', true);
            $('input[name="edit_staff_login"]').attr('readonly', true);
            $('input[name="edit_staff_password"]').val('');
            $('input[name="edit_staff_password"]').prop('readonly', true);
            $('input[name="edit_staff_password"]').prop('required', false);
        });

        $(document).on('click', '.js-create-new-staff', function() {
            self.editSecurityUserId = null;
            $(".js-business-staff-update").trigger('reset');
            $('.js-update-business-staff-dialog-title-id').html(`Cadastrar Doutor`);
            $('input[name="edit_staff_login"]').val('');
            $('input[name="edit_staff_login"]').prop('readonly', false);
            $('input[name="edit_staff_login"]').attr('readonly', false);
            $('input[name="edit_staff_password"]').val('');
            $('input[name="edit_staff_password"]').prop('readonly', false);
            $('input[name="edit_staff_password"]').prop('required', true);
        });
    }
}